import { render } from "./IconRoundaboutRight.vue?vue&type=template&id=63c2dbf4"
import script from "./IconRoundaboutRight.vue?vue&type=script&lang=js"
export * from "./IconRoundaboutRight.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__